/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const Component = ({ className, component = "/img/component-5.png" }) => {
  return <img className={`component ${className}`} alt="Component" src={component} />;
};

Component.propTypes = {
  component: PropTypes.string,
};
